import { Box, CircularProgress } from '@mui/material'

function FullPageLoader() {
  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <CircularProgress sx={{ margin: 'auto' }} />
    </Box>
  )
}

export default FullPageLoader
